import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '@services/api/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.scss'],
})
export class EditRoleComponent implements OnInit {
  @Input() isHideSideNav: boolean = true;
  @Input() role_ids: any;
  @Output() isRoleUpdate = new EventEmitter<boolean>();
  constructor(
    private Api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}
  roleForm: FormGroup;
  public role: any;
  public role_id: string;
  ngOnInit() {
    this.roleForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      description: new FormControl(),
    });

    // Get role details by id from url params
    this.route.params.subscribe({
      next: params => {
        this.role_id = params['id'];
        // Will be called if there is any id in Params
        this.getRole(this.role_id);
      },
    });

    // Get role details by id
    if (this.role_ids) {
      this.getRole(this.role_ids);
    }
  }

  // Get role details by id from API
  getRole(id = null) {
    // Check if a valid role ID is provided
    if (id) {
      // Fetch role data using the provided ID
      this.Api.get('/roles/' + id).subscribe({
        next: data => {
          // Store role data and patch form with retrieved values
          this.role = data.data;
          this.roleForm.patchValue(this.role);
        },
        error: _ => {
          // Handle errors silently (can be customized later)
        },
      });
    }
  }

  // Update role details by checking form validity and navigate to roles page
  updateRole() {
    // If form is invalid or role_id exists, return early (probably used for prevent double submissions or edit-lock)
    if (this.roleForm.invalid || this.role_id) {
      return;
    }

    // Determine the correct ID to use for updating the role
    let id = this.role_id ? this.role_id : this.role_ids;

    // Send update request to API with form values
    this.Api.put('/roles/' + id, this.roleForm.value).subscribe({
      next: _ => {
        // On success, show success message
        this.toastr.success('Role has been updated');

        // Emit update event or navigate based on context
        if (this.isHideSideNav === false) {
          this.isRoleUpdate.emit(true);
        } else {
          this.router.navigateByUrl('/setting/roles');
        }
      },
      error: error => {
        // Show specific error if not server-side, otherwise show generic error
        if (error.message && error.status_code !== 500) {
          let err = error?.message ?? error?.error?.message;
          this.toastr.error(err);
        } else {
          this.toastr.error('Something wrong with the form. Please check and try again.');
        }
      },
    });
  }
}
